import React from 'react';

export interface TabButtonProps {
  label: string;
  isActive: boolean;
  onClick: () => void;
}

export const TabButton = ({
  label,
  isActive,
  onClick,
}: TabButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`flex-1 py-2.5 px-2 font-medium text-xs transition-all ${isActive
        ? 'text-white border-b-2 border-white font-semibold'
        : 'text-white/70 hover:text-white hover:bg-white/10'
        }`}
    >
      {label}
    </button>
  );
};

